module.exports = __webpack_public_path__ + "static/ER-model-9b220bd71ae6008fffbb86d567171509.png";